import {useIntl} from 'react-intl'
import {formatPhoneNumber} from '../../utils/phone-utils'

export default function useCommunicationsFields({
    form: {
        control,
        formState: {errors}
    },
    prefix = ''
}) {
    const {formatMessage} = useIntl()

    const switchLabels = {
        on: formatMessage({
            id: 'communication_preferences.email.unsubscribe',
            defaultMessage: 'Unsubscribe'
        }),
        off: formatMessage({
            id: 'communication_preferences.email.subscribe',
            defaultMessage: 'Subscribe'
        })
    }

    const fields = {
        emailGarageOptIn: {
            name: `${prefix}emailGarageOptIn`,
            type: 'switch',
            control,
            error: errors[`${prefix}emailGarageOptIn`],
            defaultValue: false,
            switchLabels,
            switchProps: {
                sx: {
                    '&[data-checked] .chakra-switch__track': {
                        bg: 'black'
                    }
                }
            }
        },

        emailGaragePersonalizedOptIn: {
            name: `${prefix}emailGaragePersonalizedOptIn`,
            type: 'switch',
            error: errors[`${prefix}emailGaragePersonalizedOptIn`],
            control,
            defaultValue: false,
            switchLabels,
            switchProps: {
                sx: {
                    '&[data-checked] .chakra-switch__track': {
                        bg: 'black'
                    }
                }
            }
        },

        smsPhoneNumber: {
            name: `${prefix}smsPhoneNumber`,
            type: 'tel',
            placeholder: formatMessage({
                id: 'communication_preferences.sms.phone_label',
                defaultMessage: 'Phone Number (optional)'
            }),
            rules: {
                required: formatMessage({
                    id: 'communication_preferences.sms.phone_required',
                    defaultMessage: 'Phone number is required'
                }),
                pattern: {
                    value: /^[+]?[(]?[\d\s\-\(\)]{10,}$/,
                    message: formatMessage({
                        id: 'communication_preferences.sms.phone_invalid',
                        defaultMessage: 'Please enter a valid phone number'
                    })
                }
            },
            error: errors[`${prefix}smsPhoneNumber`],
            control,
            inputProps: ({onChange}) => ({
                inputMode: 'numeric',
                'data-testid': 'communication-sms-phone-input',
                onChange(evt) {
                    onChange(formatPhoneNumber(evt.target.value))
                },
                sx: {
                    border: '1px solid #939393',
                    padding: '8px',
                    height: '48px',
                    fontSize: '14px'
                }
            }),
            hideLabel: true
        },

        languagePreference: {
            name: `${prefix}languagePreference`,
            type: 'radio',
            options: [
                {
                    label: formatMessage({
                        id: 'account_detail.language.french',
                        defaultMessage: 'French (Français)'
                    }),
                    value: 'fr'
                },
                {
                    label: formatMessage({
                        id: 'account_detail.language.english',
                        defaultMessage: 'English'
                    }),
                    value: 'en'
                }
            ],
            rules: {
                required: formatMessage({
                    id: 'account_detail.language.required',
                    defaultMessage: 'Please select a language'
                })
            },
            error: errors[`${prefix}languagePreference`],
            control,
            defaultValue: 'fr'
        }
    }

    return fields
}
